export default __webpack_public_path__ + "static/media/carta10.e6be8f51.png";